<template lang="html">
  <section class="month">
    <v-overlay data-cy="loading-overlay" :value="this.showMonthLoadingOverlay" absolute />

    <Flicker 
      :loading="this.loading"
      :sticky="true"
      :bottomText="this.isMonthFromMonatsabschluss ? '(Monatsabschluss)' : ''"
      @changeRoute="this.changeRoute">
      <template v-slot:rightTemplate>
        <div v-if="!isMonthFromMonatsabschluss && !loading">
          <v-tooltip right :open-on-focus="false">
            <template v-slot:activator="{ on }">
              <v-btn id="addTimeEntryBtn" fab small color="#c00000" class="ml-4 white--text" @click="createTimeEntry({})" v-on="on">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Neuen Zeiteintrag anlegen</span>
          </v-tooltip>
        </div>
      </template>
    </Flicker>

    <CreateEditTimeEntry ref="createEditTimeEntry" :dayData="{}" :alterOriginalEntries="true"></CreateEditTimeEntry>

    <section id="showMonthData" v-show="this.showMonth">
      <MonthTable v-if="this.monthData.weeks"
        :monthData="this.monthData" :entryUpdateEnabled="isMonthFromMonatsabschluss == false && global.impersonationID == undefined" :attachments="this.attachments">
      </MonthTable>

      <!-- Monatsabschluss -->
      <v-row class="justify-center">
        <!-- TODO: remove && this.monthData.closing.timestamp check later when we can be sure that all users use this version -->
        <v-col cols="11">
          <v-row class="justify-end">
            <v-col cols="auto">
              <v-card v-if="this.isMonthFromMonatsabschluss && this.monthData.closing && this.monthData.closing.timestamp"
                class="d-flex flex-column text-center" flat color='transparent'>
                <label class="grey--text overline">Abgeschlossen am</label>
                <label id="timestamp">{{ formatTimestamp(this.monthData.closing.timestamp) }}</label>
              </v-card>
            </v-col>
            
            <v-col cols="auto">
              <v-card v-if="this.monthData.closing" class="d-flex flex-column text-center" flat color='transparent'>
                <label class="grey--text overline">
                  Status
                  <v-tooltip v-if="this.monthData.closing.latestComment" color="grey darken-4" right>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="grey lighten-1">mdi-message</v-icon>
                    </template>
                    <div id="commentbody" style="white-space: pre-line;">{{ this.monthData.closing.latestComment.body }}</div>
                  </v-tooltip>
                </label>
                <label id="status">{{ monthData.closing.status }}</label>
              </v-card>
            </v-col>
            
            <v-col cols="auto">
              <v-btn-toggle v-if="this.monthSubmitable" dense class="ml-4">
                <v-btn id="submitMonth" color="#c00000" class="white--text" @click="submitMonth()">
                  Monat abschließen
                </v-btn>
                <v-btn id="submitMonthWithComment" color="#c00000" class="white--text" @click="submitMonthWithComment()">
                  <v-icon color="white">mdi-message</v-icon>
                </v-btn>
              </v-btn-toggle>

              <v-btn-toggle v-if="this.monthFixable" dense class="ml-4">
                <v-btn id="fixMonth" color="#c00000" class="white--text" @click="fixMonth()">
                  Erneut abschließen
                </v-btn>
                <v-btn id="fixMonthWithComment" color="#c00000" class="white--text" @click="fixMonthWithComment()">
                  <v-icon color="white">mdi-message</v-icon>
                </v-btn>
              </v-btn-toggle>

              <v-btn-toggle v-if="this.monthRejectable" dense class="ml-4">
                <v-btn id="rejectMonth" color="#c00000" class="white--text" @click="rejectMonth()">
                  Zurückziehen
                </v-btn>
                <v-btn id="rejectMonthWithComment" color="#c00000" class="white--text" @click="rejectMonthWithComment()">
                  <v-icon color="white">mdi-message</v-icon>
                </v-btn>
              </v-btn-toggle>

              <v-btn-toggle v-if="this.showGotoTicket" dense class="ml-4">
                <v-btn id="gotoJiraTicket" color="#c00000" class="white--text"
                  :href="global.JIRA_SERVER_URL + '/browse/' + monthData.closing.jiraKey" target="_blank">
                  Jira Ticket
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- /Monatsabschluss -->

    </section>

    <ConfirmExtended ref="confTransition"></ConfirmExtended>
    <ConfirmExtended ref="confMonatsabschluss"></ConfirmExtended>
    <Confirm ref="confJump" confirmButtonText="Ja" cancelButtonText="Nein"></Confirm>
    <Confirm ref="confNotFound" confirmButtonText="Weiter" :cancelButtonText="null"></Confirm>
  </section>
</template>

<script lang="js">
import dayjs from '@util/dayjs';

import Flicker from '@components/Flicker.vue';
import MonthTable from '@components/user/MonthTable.vue'
import Confirm from '@components/Confirm.vue';
import ConfirmExtended from '@components/ConfirmExtended.vue';
import CreateEditTimeEntry from '@components/CreateEditTimeEntry.vue';
import JiraMonatsabschluss from '@/mixins/JiraMonatsabschluss.vue'

import * as sqtClient from '@client/client.sqt';
import * as monatsabschlussClient from '@client/client.monatsabschluss';
import * as mocoClient from '@client/client.moco';

export default {
  name: 'Monatsansicht',
  components: {
    Confirm,
    ConfirmExtended,
    MonthTable,
    Flicker,
    CreateEditTimeEntry
  },

  mixins: [JiraMonatsabschluss],

  created() {
    this.$root.$on('startLoading', this.startLoading);
    this.$root.$on('reload', this.loadMonth);
  },

  mounted() {
    this.initialLoadMonth();
  },

  beforeDestroy() {
    this.$root.$off('startLoading', this.startLoading);
    this.$root.$off('reload', this.loadMonth);
  },

  data() {
    return {
      loading: false,
      initialMonthLoad: true,
      isMonthFromMonatsabschluss: false,
      monthData: {
        /*closing: {
          status: undefined, // wg. reactiviy
          jiraKey: undefined // wg. reactiviy
        },
        hours: {}, // wg. sicherem Zugriff auf monthData.hours.X
        holidays: {}, // wg. sicherem Zugriff auf monthData.holidays.X*/
      },
      attachments: []
    }
  },

  computed: {
    showMonth: function () {
      return this.showMonthLoadingOverlay || (this.loading == false);
    },

    showMonthLoadingOverlay: function () {
      return this.loading && this.initialMonthLoad == false;
    },

    monatsabschlussStillOpenConfirmed: function () {
      return this.$store.state.confirmations.MonatsabschlussStillOpen == 'confirmed';
    },

    displayedDate: function () {
      return this.$store.state.displayedMonth;
    }
  },

  methods: {
    createTimeEntry() {
      if (this.entryUpdateEnabled == false) {
        return;
      }
      const activities = this.monthData.activities;
      const latestActivity = this.getLastCreatedActivity(activities);
      this.$refs.createEditTimeEntry.createTimeEntry(
        latestActivity?.project,
        latestActivity?.task
      );
    },

    getLastCreatedActivity(activities) {
      if (!activities || activities.length === 0) {
        return null;
      } 

      return activities.reduce((latest, current) => {
        return dayjs(current.created_at).isAfter(dayjs(latest.created_at)) 
          ? current 
          : latest;
      });
    },

    startLoading() {
      this.loading = true;
    },

    async initialLoadMonth() {
      this.initialMonthLoad = true;
      this.isMonthFromMonatsabschluss = false;

      await this.loadMonth();
    },

    loadTodaysMonth() {
      this.changeRoute(dayjs().date(1));
    },

    async loadMonth() {
      this.loading = true;
      const res = await this.$draf(async () => {
        const staticUserData = this.$store.getters.staticUserData;
        if (staticUserData == undefined || this.$store.getters.userAuthenticationData.mocoApiKey == undefined) {
          return;
        }

        const jiraTicket = await monatsabschlussClient.getMonatsabschluss(undefined, staticUserData.user.email, this.displayedDate.isoMonth(), this.displayedDate.year());
        this.attachments = jiraTicket?.attachments;
        if (jiraTicket && jiraTicket.status != global.monthClosing.status.open) {
          if (!jiraTicket.month) {
            await this.openConfirmation(this.$refs.confNotFound, 'Monatsdaten nicht gefunden',
              `Die Monatsdaten konnten nicht aus dem Jira-Ticket (${jiraTicket.jiraKey}) geladen werden. Sie werden nun zum aktuellen Monat weitergeleitet.`);
            return () => { this.changeRoute(dayjs().date(1)) };
          }

          if (jiraTicket.status === global.monthClosing.status.rejected) {
            // Wenn "Rejected" muss das Monat aus den realen Moco Daten geladen werden, damit man die Änderungen im SEQITRacker sieht und erneut abschließen kann
            await this.loadMonthFromMoco();
            this.monthData.closing.latestComment = jiraTicket.latestComment;
          } else {
            this.isMonthFromMonatsabschluss = true;
            this.loadMonthFromJiraTicket(jiraTicket);
          }
        } else {
          await this.loadMonthFromMoco();

          if (this.displayedDate.isBefore(dayjs().subtract(1, 'month'), 'month')) {
            await this.openConfirmation(this.$refs.confNotFound, 'Monatsabschluss nicht gefunden',
              'Für diesen Monat wurde kein Monatsabschluss gefunden, obwohl er schon mehrere Monate zurück liegt. Die Daten, die jetzt angezeigt werden kommen direkt von Moco. Falls der Monat eigentlich schon abgeschlossen ist warte kurz und lad die Seite dann neu. :)');
          }
        }

        const prevDate = dayjs().subtract(1, 'months');
        const prevMonthJiraTicket = await monatsabschlussClient.getMonatsabschluss(undefined, staticUserData.user.email, prevDate.isoMonth(), prevDate.year()); // TODO ohne monthData laden

        if (this.monatsabschlussStillOpenConfirmed == false && (prevMonthJiraTicket == undefined || prevMonthJiraTicket == '')
          && dayjs(staticUserData.user.activeEmployment.from).isBefore(this.displayedDate.startOf('month'))) {
          // previous month was not submitted
          if (this.displayedDate.isSame(prevDate, 'month') == false) {
            this.$store.dispatch('setConfirmation', { confirmation: 'MonatsabschlussStillOpen', status: 'confirmed' });
            if (await this.openConfirmation(this.$refs.confJump, 'Zu offenem Monat springen?',
              'Der Abschluss eines vergangenen Monats ist noch nicht erfolgt. Wollen Sie zu diesem wechseln?')) {
              return () => { this.changeRoute(prevDate) };
            }
          }
        }
      });

      this.initialMonthLoad = false;
      this.loading = false;
      if (typeof (res) == 'function') {
        res();
      }
    },

    async loadMonthFromMoco() {
      this.isMonthFromMonatsabschluss = false;

      const staticUserData = this.$store.getters.staticUserData;
      const startOfMonth = this.displayedDate.startOf('month').startOf('day');
      const endOfMonth = this.displayedDate.endOf('month').endOf('day');

      const activitiesPromise = mocoClient.getActivities(startOfMonth, endOfMonth);
      const presencesPromise = mocoClient.getPresences(startOfMonth, endOfMonth);

      const [activities, presences] = await Promise.all([activitiesPromise, presencesPromise]);

      this.monthData = await sqtClient.getMonatsdaten(
        this.displayedDate.isoMonth(), this.displayedDate.year(),
        activities, presences,
        staticUserData.userEmployments, staticUserData.userHolidays, staticUserData.schedules,
        this.$store.getters.enabledRules
      );
    },

    async openConfirmation(confirm, title, message) {
      this.loading = false;
      return await confirm.open(title, message);
    },

    changeRoute(displayedDate) {
      const monatsansichtUrl = {
        name: global.ROUTES.monatsansicht.name,
        params: {
          year: displayedDate.year(),
          month: displayedDate.isoMonth()
        }
      };

      if (this.$route.query?.impersonation) {
        monatsansichtUrl.query = { impersonation: this.$route.query.impersonation };
      }

      this.$router.push(monatsansichtUrl);
    }
  },

  watch: {
    displayedDate: function () {
      this.initialLoadMonth();
    }
  }
}
</script>
<style type="scss">
#commentbody {
  white-space: pre-line;
}

.v-btn-toggle {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.v-btn-toggle > .v-btn {
  opacity: 1 !important;
}
</style>